import React from 'react';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faPlus, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

import './menu.scss'
import MenuList from "./MenuList";

import { menu } from '../../../Constants'

library.add(faCog, faPlus, faSignOutAlt);

export default function Menu(props) {
    const menuList = menu.map(list => <MenuList key={list.id} info={list}/>);
    const { history } = props;
    return (
        <div id='menu'>
            <div className='header'>
                <div id='headerMenu'><FontAwesomeIcon icon='cog'/>Մենու</div>
                <div id='logOut' title='Log Out' onClick={ logout(history) }><FontAwesomeIcon icon='sign-out-alt'/></div>
            </div>
            <section>{menuList}</section>
        </div>
    )
}

function logout(history) {
    return function () {
        axios.post('/api/logout').then(result => {
            if (result.data.message === 'You logged out')
                history.push('/admin');
        })
    }
}
